/* fiveaven (20/10/2026) : loupe des produits d'un pack (snippets/fv-pack-contenu.liquid).
   Un clic sur la loupe ou sur la ligne ouvre la fiche du produit sur la moitié droite de l'écran (bas de l'écran sur mobile),
   le reste flouté. Contenu : /products/<handle>?view=fvm-panneau (la fiche de Mon compte). Flèches pour passer d'un produit
   du pack à l'autre, Échap ou clic sur le flou pour fermer. Ctrl/Cmd + clic sur une ligne garde le lien normal. */
(() => {
  const racine = document.querySelector('[data-fvpk]');
  if (!racine || racine.dataset.fvpkPret) return;
  racine.dataset.fvpkPret = '1';

  const items = [...racine.querySelectorAll('.fvpk__lien')].map((a) => ({ url: a.getAttribute('href'), nom: a.querySelector('b').textContent.trim() }));
  if (!items.length) return;
  const cache = {};
  let voile, pan, corps, compte, btn, prec, suiv, courant = 0, retour = null;

  const ico = {
    prec: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    suiv: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>',
    x: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
  };

  const vue = (url) => url + (url.includes('?') ? '&' : '?') + 'view=fvm-panneau';

  function charger(i) {
    const url = items[i].url;
    if (!cache[url]) {
      cache[url] = fetch(vue(url), { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .catch((e) => { delete cache[url]; throw e; });
    }
    return cache[url];
  }

  function construire() {
    voile = document.createElement('div');
    voile.className = 'fvpk-voile';
    pan = document.createElement('aside');
    pan.className = 'fvpk-pan';
    pan.setAttribute('role', 'dialog');
    pan.setAttribute('aria-modal', 'true');
    pan.setAttribute('aria-label', 'Fiche produit');
    pan.tabIndex = -1;
    pan.innerHTML =
      '<div class="fvpk-pan__tete"><p class="fvpk-pan__compte"></p><div class="fvpk-pan__nav">' +
      (items.length > 1 ? '<button type="button" data-fvpk-prec aria-label="Produit précédent">' + ico.prec + '</button><button type="button" data-fvpk-suiv aria-label="Produit suivant">' + ico.suiv + '</button>' : '') +
      '<button type="button" class="fvpk-pan__x" data-fvpk-fermer aria-label="Fermer">' + ico.x + '</button></div></div>' +
      '<div class="fvpk-pan__corps"></div>' +
      '<div class="fvpk-pan__pied"><a class="fvpk-pan__btn" href="#">Voir la fiche complète</a></div>';
    document.body.append(voile, pan);
    corps = pan.querySelector('.fvpk-pan__corps');
    compte = pan.querySelector('.fvpk-pan__compte');
    btn = pan.querySelector('.fvpk-pan__btn');
    prec = pan.querySelector('[data-fvpk-prec]');
    suiv = pan.querySelector('[data-fvpk-suiv]');
    voile.addEventListener('click', fermer);
    pan.querySelector('[data-fvpk-fermer]').addEventListener('click', fermer);
    if (prec) prec.addEventListener('click', () => montrer(courant - 1));
    if (suiv) suiv.addEventListener('click', () => montrer(courant + 1));
    pan.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); fermer(); }
      if (e.key === 'Tab') garderFocus(e);
    });
  }

  function garderFocus(e) {
    const f = [...pan.querySelectorAll('a[href],button:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')].filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const a = f[0], z = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === a || document.activeElement === pan)) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }

  function montrer(i) {
    if (i < 0 || i >= items.length) return;
    courant = i;
    const it = items[i];
    compte.textContent = 'Dans ce pack · ' + (i + 1) + ' sur ' + items.length;
    pan.setAttribute('aria-label', it.nom);
    btn.href = it.url;
    if (prec) prec.disabled = i === 0;
    if (suiv) suiv.disabled = i === items.length - 1;
    corps.classList.add('is-charge');
    charger(i).then((html) => {
      if (courant !== i) return;
      corps.innerHTML = html;
      corps.scrollTop = 0;
      corps.classList.remove('is-charge');
      if (items[i + 1]) charger(i + 1).catch(() => {});
    }).catch(() => {
      if (courant !== i) return;
      corps.classList.remove('is-charge');
      corps.innerHTML = '<p style="padding:0 24px;font-size:14px">La fiche ne s\'est pas chargée. <a href="' + it.url + '" style="color:inherit;text-decoration:underline">Ouvrir la fiche du produit</a></p>';
    });
  }

  function ouvrir(i, depuis) {
    if (!pan) construire();
    retour = depuis || document.activeElement;
    montrer(i);
    document.documentElement.classList.add('fvpk-ouvert');
    requestAnimationFrame(() => {
      voile.classList.add('is-ouvert');
      pan.classList.add('is-ouvert');
      pan.focus({ preventScroll: true });
    });
  }

  function fermer() {
    if (!pan) return;
    voile.classList.remove('is-ouvert');
    pan.classList.remove('is-ouvert');
    document.documentElement.classList.remove('fvpk-ouvert');
    if (retour && retour.focus) retour.focus({ preventScroll: true });
  }

  racine.addEventListener('click', (e) => {
    const cible = e.target.closest('.fvpk__lien, .fvpk__loupe');
    if (!cible) return;
    if (cible.matches('.fvpk__lien') && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0)) return;
    e.preventDefault();
    ouvrir(Number(cible.dataset.fvpkI) || 0, cible);
  });
  racine.addEventListener('pointerenter', (e) => {
    const cible = e.target.closest && e.target.closest('.fvpk__item');
    if (!cible) return;
    const l = cible.querySelector('.fvpk__lien');
    if (l) charger(Number(l.dataset.fvpkI) || 0).catch(() => {});
  }, true);
})();
